import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import {
    Row,
    Column,
    Label,
    Select,
    SelectWrapper,
    ControlLabel,
    SettingsGroup,
    StyledSwitch,
    Input
} from '../../../styles/WidgetCustomizer.styles';
import {
    StyleOptions,
    StyleOption,
    ShapeExample
} from './LayoutTab.styles';
import UnitInput from '../../UnitInput/UnitInput';

const LayoutTab = ({
    style,
    setStyle,
    settings,
    setSettings,
    textAlign,
    setTextAlign,
    albumArt,
    setAlbumArt,
    fontFamily,
    setFontFamily,
    fontSize,
    setFontSize,
    fontWeight,
    setFontWeight,
    fontSpacing,
    setFontSpacing,
    buttonStyle,
    setButtonStyle,
    dimensions,
    setDimensions,
    buttonAlign,
    setButtonAlign,
    playerType
}) => {
    const handleDimensionChange = (property, { value, unit }) => {
        setDimensions(prev => ({
            ...prev,
            [property]: `${value}${unit}`
        }));
    };

    return (
        <>
            <Row>
                <Column>
                    <Label>Style</Label>
                    {playerType === 'sticky' ? (
                        <StyleOptions>
                            <StyleOption
                                selected={style === 'footer'}
                                onClick={() => setStyle('footer')}
                            >
                                <ShapeExample type="horizontal" selected={style === 'footer'} />
                                Footer
                            </StyleOption>
                            <StyleOption
                                selected={style === 'compact'}
                                onClick={() => setStyle('compact')}
                            >
                                <ShapeExample type="horizontal" selected={style === 'compact'} />
                                Compact
                            </StyleOption>
                        </StyleOptions>
                    ) : (
                        <StyleOptions>
                            <StyleOption
                                selected={style === 'vertical'}
                                onClick={() => setStyle('vertical')}
                            >
                                <ShapeExample type="vertical" selected={style === 'vertical'} />
                                Vertical
                            </StyleOption>
                            <StyleOption
                                selected={style === 'horizontal'}
                                onClick={() => setStyle('horizontal')}
                            >
                                <ShapeExample type="horizontal" selected={style === 'horizontal'} />
                                Horizontal
                            </StyleOption>
                            <StyleOption
                                selected={style === 'square'}
                                onClick={() => setStyle('square')}
                            >
                                <ShapeExample type="square" selected={style === 'square'} />
                                Square
                            </StyleOption>
                        </StyleOptions>
                    )}
                </Column>
            </Row>

            <Row>
                <Column>
                    <ControlLabel>
                        Volume control
                        <StyledSwitch
                            checked={settings.volumeControl}
                            onChange={(checked) => setSettings(prev => ({ ...prev, volumeControl: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
                <Column>
                    <ControlLabel>
                        Song history
                        <StyledSwitch
                            checked={settings.songHistory}
                            onChange={(checked) => setSettings(prev => ({ ...prev, songHistory: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
            </Row>

            <Row>
                <Column>
                    <ControlLabel>
                        Song name
                        <StyledSwitch
                            checked={settings.songName}
                            onChange={(checked) => setSettings(prev => ({ ...prev, songName: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
                <Column>
                    <ControlLabel>
                        Artist name
                        <StyledSwitch
                            checked={settings.artistName}
                            onChange={(checked) => setSettings(prev => ({ ...prev, artistName: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
            </Row>

            <Row>
                <Column>
                    <ControlLabel>
                        Time
                        <StyledSwitch
                            checked={settings.time}
                            onChange={(checked) => setSettings(prev => ({ ...prev, time: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
                <Column>
                    <ControlLabel>
                        Time bar
                        <StyledSwitch
                            checked={settings.timeBar}
                            onChange={(checked) => setSettings(prev => ({ ...prev, timeBar: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
            </Row>

            <Row>
                <Column>
                    <ControlLabel>
                        Radio name
                        <StyledSwitch
                            checked={settings.radioName}
                            onChange={(checked) => setSettings(prev => ({ ...prev, radioName: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
                <Column>
                    <ControlLabel>
                        Live indicator
                        <StyledSwitch
                            checked={settings.liveIndicator}
                            onChange={(checked) => setSettings(prev => ({ ...prev, liveIndicator: checked }))}
                            height={24}
                            width={44}
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            offColor="#e0e0e0"
                            onColor="#4AE66E"
                            boxShadow="none"
                        />
                    </ControlLabel>
                </Column>
            </Row>

            <SettingsGroup>
                <Row>
                    <Column>
                        <Label>Text alignment</Label>
                        <SelectWrapper>
                            <Select value={textAlign} onChange={(e) => setTextAlign(e.target.value)}>
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                            </Select>
                            <FontAwesomeIcon icon={faCaretDown} className="select-icon" />
                        </SelectWrapper>
                    </Column>
                    <Column>
                        <Label>Button alignment</Label>
                        <SelectWrapper>
                            <Select value={buttonAlign} onChange={(e) => setButtonAlign(e.target.value)}>
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                            </Select>
                            <FontAwesomeIcon icon={faCaretDown} className="select-icon" />
                        </SelectWrapper>
                    </Column>
                </Row>

                <Row>
                    <Column>
                        <Label>Album art</Label>
                        <SelectWrapper>
                            <Select value={albumArt} onChange={(e) => setAlbumArt(e.target.value)}>
                                <option value="contain">Contain</option>
                                <option value="cover">Cover</option>
                                <option value="disable">Disable</option>
                            </Select>
                            <FontAwesomeIcon icon={faCaretDown} className="select-icon" />
                        </SelectWrapper>
                    </Column>
                </Row>

                <Row>
                    <Column>
                        <Label>Font size</Label>
                        <UnitInput
                            value={fontSize.value}
                            units={['px', 'rem']}
                            defaultUnit="rem"
                            onChange={({ value, unit }) => {
                                const numericValue = parseFloat(value) || (unit === 'rem' ? 1 : 14);
                                setFontSize({ value: numericValue, unit });
                            }}
                        />
                    </Column>
                    <Column>
                        <Label>Font weight</Label>
                        <SelectWrapper>
                            <Select value={fontWeight} onChange={(e) => setFontWeight(e.target.value)}>
                                <option value="300">Light</option>
                                <option value="400">Regular</option>
                                <option value="500">Medium</option>
                                <option value="600">Semi Bold</option>
                                <option value="700">Bold</option>
                            </Select>
                            <FontAwesomeIcon icon={faCaretDown} className="select-icon" />
                        </SelectWrapper>
                    </Column>
                </Row>

                <Row>
                    <Column>
                        <Label>Letter spacing</Label>
                        <UnitInput
                            value={fontSpacing.letterSpacing.value}
                            unit={fontSpacing.letterSpacing.unit}
                            units={['px', 'rem']}
                            defaultUnit="px"
                            onChange={({ value, unit }) => setFontSpacing(prev => ({
                                ...prev,
                                letterSpacing: { value, unit }
                            }))}
                        />
                    </Column>
                    <Column>
                        <Label>Line height</Label>
                        <UnitInput
                            value={fontSpacing.lineHeight.value}
                            unit={fontSpacing.lineHeight.unit}
                            units={['px', 'rem']}
                            defaultUnit="px"
                            onChange={({ value, unit }) => setFontSpacing(prev => ({
                                ...prev,
                                lineHeight: { value, unit }
                            }))}
                        />
                    </Column>
                </Row>

                <Row>
                    <Column>
                        <Label>Word spacing</Label>
                        <UnitInput
                            value={fontSpacing.wordSpacing.value}
                            unit={fontSpacing.wordSpacing.unit}
                            units={['px', 'rem']}
                            defaultUnit="px"
                            onChange={({ value, unit }) => setFontSpacing(prev => ({
                                ...prev,
                                wordSpacing: { value, unit }
                            }))}
                        />
                    </Column>
                    <Column>
                        <Label>Buttons style</Label>
                        <SelectWrapper>
                            <Select value={buttonStyle} onChange={(e) => setButtonStyle(e.target.value)}>
                                <option value="circle">Circle</option>
                                <option value="square">Square</option>
                                <option value="rounded">Rounded</option>
                                <option value="text">Just Text</option>
                                <option value="icons">Just Icons</option>
                            </Select>
                            <FontAwesomeIcon icon={faCaretDown} className="select-icon" />
                        </SelectWrapper>
                    </Column>
                </Row>
            </SettingsGroup>

            <Row>
                <Column>
                    <Label>Border size</Label>
                    <UnitInput
                        value={dimensions.borderSize.replace('px', '')}
                        units={['px']}
                        defaultUnit="px"
                        onChange={(values) => handleDimensionChange('borderSize', values)}
                    />
                </Column>
                <Column>
                    <Label>Border radius</Label>
                    <UnitInput
                        value={dimensions.borderRadius.replace('px', '')}
                        units={['px', '%']}
                        defaultUnit="px"
                        onChange={(values) => handleDimensionChange('borderRadius', values)}
                    />
                </Column>
            </Row>

            <Row>
                <Column>
                    <Label>Player width</Label>
                    <UnitInput
                        value={dimensions.width.replace(/[a-z%]/g, '')}
                        units={['px', '%', 'auto']}
                        defaultUnit="auto"
                        onChange={(values) => handleDimensionChange('width', values)}
                    />
                </Column>
                <Column>
                    <Label>Player height</Label>
                    <UnitInput
                        value={dimensions.height.replace(/[a-z%]/g, '')}
                        units={['px', '%', 'auto']}
                        defaultUnit="auto"
                        onChange={(values) => handleDimensionChange('height', values)}
                    />
                </Column>
            </Row>

            <Row>
                <Column>
                    <Label>Outer space</Label>
                    <UnitInput
                        value={dimensions.padding.replace('px', '')}
                        units={['px']}
                        defaultUnit="px"
                        onChange={(values) => handleDimensionChange('padding', values)}
                    />
                </Column>
                <Column>
                    <Label>Inner space</Label>
                    <UnitInput
                        value={dimensions.margin.replace('px', '')}
                        units={['px']}
                        defaultUnit="px"
                        onChange={(values) => handleDimensionChange('margin', values)}
                    />
                </Column>
            </Row>
        </>
    );
};

export default LayoutTab; 